import { render, staticRenderFns } from "./award-levitated-sphere.vue?vue&type=template&id=20300bff&scoped=true&lang=pug&"
import script from "./award-levitated-sphere.vue?vue&type=script&lang=js&"
export * from "./award-levitated-sphere.vue?vue&type=script&lang=js&"
import style0 from "./award-levitated-sphere.vue?vue&type=style&index=0&id=20300bff&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20300bff",
  null
  
)

export default component.exports